import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=190dff9c&scoped=true&"
var script = {}
import style0 from "./menu.vue?vue&type=style&index=0&id=190dff9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190dff9c",
  null
  
)

export default component.exports